// extracted by mini-css-extract-plugin
export default {"brand-colors":"brand-colors_brand-colors__dgyHw","brand-colors__main":"brand-colors_brand-colors__main__tc7lZ"};